/* ======================================================================
   ANDHEKA — Product page interactions
   Gallery hover-video · size selection · illuminated detail reveal ·
   sticky buy bar · size-chart drawer · fit finder (three taps).
   Cart add + inventory guard are handled by andheka-cart.js.
   ====================================================================== */
(function () {
  'use strict';

  document.querySelectorAll('[data-product-root]').forEach(function (root) {

    /* ---------- gallery: cover turns to video on hover ---------- */
    root.querySelectorAll('[data-hover-video]').forEach(function (v) {
      var shot = v.closest('.ac-pdp-shot, .ac-pdp-mob-shot');
      if (!shot) return;
      shot.addEventListener('mouseenter', function () { shot.classList.add('is-live'); try { v.currentTime = 0; var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} });
      shot.addEventListener('mouseleave', function () { if (!shot.hasAttribute('data-live-scroll')) { shot.classList.remove('is-live'); try { v.pause(); } catch (e) {} } });
    });

    /* ---------- first shot plays live as it scrolls into view (desktop + mobile) ---------- */
    if ('IntersectionObserver' in window) {
      var firstShots = [root.querySelector('.ac-pdp-gallery .ac-pdp-shot [data-hover-video]'), root.querySelector('.ac-pdp-mob-shot [data-hover-video]')];
      firstShots.forEach(function (v) {
        if (!v) return;
        var shot = v.closest('.ac-pdp-shot, .ac-pdp-mob-shot');
        shot.setAttribute('data-live-scroll', '');
        new IntersectionObserver(function (ents) {
          ents.forEach(function (en) {
            if (en.isIntersecting) { shot.classList.add('is-live'); try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
            else { shot.classList.remove('is-live'); try { v.pause(); } catch (e) {} }
          });
        }, { threshold: 0.55 }).observe(shot);
      });
    }

    /* ---------- size selection ---------- */
    var forms = root.querySelectorAll('[data-pdp-form]');
    var form = forms[0];
    var vInput = form && form.querySelector('[data-variant-input]');
    var priceEls = root.querySelectorAll('[data-pdp-price]');
    var sizeBtns = root.querySelectorAll('.ac-pdp-size');

    function selectSize(size) {
      var chosen = null;
      sizeBtns.forEach(function (b) {
        var on = b.dataset.size === size;
        b.classList.toggle('is-active', on);
        if (on && !b.hasAttribute('data-soldout')) chosen = b;
      });
      if (!chosen) return;
      var vid = chosen.dataset.variantId || '';
      /* write the chosen variant into EVERY form (desktop + mobile + buy bar) */
      root.querySelectorAll('[data-variant-input]').forEach(function (i) { i.value = vid; });
      forms.forEach(function (f) {
        if (chosen.dataset.max !== undefined) f.dataset.max = chosen.dataset.max; else delete f.dataset.max;
      });
      if (chosen.dataset.price) priceEls.forEach(function (el) { el.textContent = chosen.dataset.price; });
      root.querySelectorAll('[data-add-error]').forEach(function (e) { e.hidden = true; });
      root.querySelectorAll('.ac-pdp-sizeerr').forEach(function (e) { e.hidden = true; });
    }
    sizeBtns.forEach(function (b) {
      if (b.hasAttribute('data-soldout')) return;
      b.addEventListener('click', function () { selectSize(b.dataset.size); });
    });
    /* single-variant products: pre-select so no size step is needed */
    var live = root.querySelectorAll('.ac-pdp-size:not([data-soldout])');
    if (live.length === 1) selectSize(live[0].dataset.size);

    /* require a size before adding, on every form (capture = before cart handler) */
    forms.forEach(function (f) {
      f.addEventListener('submit', function (e) {
        var vi = f.querySelector('[data-variant-input]');
        if (!vi || !vi.value) {
          e.preventDefault();
          e.stopImmediatePropagation();
          f.querySelectorAll('.ac-pdp-sizeerr').forEach(function (el) { el.hidden = false; });
        }
      }, true);
    });

    /* ---------- illuminated detail reveal (nothing shows until hover) ---------- */
    var detWords = root.querySelectorAll('.ac-pdp-detword');
    var detBodies = root.querySelectorAll('.ac-pdp-detbody');
    function showDetail(k) {
      detWords.forEach(function (w) { w.classList.toggle('is-active', w.dataset.k === k); });
      detBodies.forEach(function (b) { b.classList.toggle('is-active', b.dataset.k === k); });
    }
    function hideDetail() {
      detWords.forEach(function (w) { w.classList.remove('is-active'); });
      detBodies.forEach(function (b) { b.classList.remove('is-active'); });
    }
    detWords.forEach(function (w) { w.addEventListener('mouseenter', function () { showDetail(w.dataset.k); }); });
    var detWrap = root.querySelector('[data-detail-wrap]');
    if (detWrap && detWords.length) {
      detWrap.addEventListener('mouseleave', hideDetail);
      hideDetail();
    }

    /* ---------- (sticky buy bar removed per brief) ---------- */

    /* ---------- size chart drawer ---------- */
    var chart = root.querySelector('[data-chart]');
    var chartScrim = root.querySelector('[data-chart-scrim]');
    var fit = root.querySelector('[data-fit]');
    function anyOpen() { return (chart && chart.classList.contains('is-open')) || (fit && fit.classList.contains('is-open')); }
    function syncHeader() { document.documentElement.classList.toggle('ac-pdp-overlay', anyOpen()); }
    function openChart() { if (chart) { chart.classList.add('is-open'); chart.hidden = false; } if (chartScrim) chartScrim.classList.add('is-open'); document.body.style.overflow = 'hidden'; syncHeader(); }
    function closeChart() { if (chart) chart.classList.remove('is-open'); if (chartScrim) chartScrim.classList.remove('is-open'); if (!anyOpen()) document.body.style.overflow = ''; syncHeader(); }
    root.querySelectorAll('[data-open-chart]').forEach(function (b) { b.addEventListener('click', openChart); });
    root.querySelectorAll('[data-close-chart]').forEach(function (b) { b.addEventListener('click', closeChart); });

    /* ---------- mobile risen card ---------- */
    var mobCard = root.querySelector('[data-mob-card]');
    var mobScrim = root.querySelector('[data-mob-scrim]');
    function mobUp() { if (mobCard) mobCard.classList.add('is-up'); if (mobScrim) mobScrim.classList.add('is-up'); }
    function mobDown() { if (mobCard) mobCard.classList.remove('is-up'); if (mobScrim) mobScrim.classList.remove('is-up'); }
    root.querySelectorAll('[data-mob-toggle]').forEach(function (t) { t.addEventListener('click', function () { (mobCard && mobCard.classList.contains('is-up')) ? mobDown() : mobUp(); }); });
    if (mobScrim) mobScrim.addEventListener('click', mobDown);
    /* tuck the docked card away once the footer is in view, so it never covers the footer */
    var footEl = document.querySelector('.ac-footer, [id*="section-footer"], footer');
    if (footEl && mobCard && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { mobDown(); mobCard.classList.add('ac-mob-hidden'); }
          else mobCard.classList.remove('ac-mob-hidden');
        });
      }, { threshold: 0.02 }).observe(footEl);
    }

    /* unit toggle */
    function setUnit(u) {
      root.querySelectorAll('[data-unit-cell]').forEach(function (c) { c.textContent = c.dataset[u] || c.dataset.in; });
      root.querySelectorAll('[data-unit-btn]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.unitBtn === u); });
    }
    root.querySelectorAll('[data-unit-btn]').forEach(function (b) { b.addEventListener('click', function () { setUnit(b.dataset.unitBtn); }); });

    /* row hover scales the drawer shirt */
    var chartShirt = root.querySelector('[data-chart-shirt]');
    var rows = root.querySelectorAll('[data-chart-row]');
    rows.forEach(function (r, i) {
      r.addEventListener('mouseenter', function () {
        rows.forEach(function (x) { x.classList.remove('is-hover'); });
        r.classList.add('is-hover');
        if (chartShirt) { var w = 0.9 + i * 0.045, h = 0.96 + i * 0.016; chartShirt.style.transform = 'scaleX(' + w + ') scaleY(' + h + ')'; }
      });
    });
    var chartWrap = root.querySelector('[data-chart-body]');
    if (chartWrap) chartWrap.addEventListener('mouseleave', function () { rows.forEach(function (x) { x.classList.remove('is-hover'); }); if (chartShirt) chartShirt.style.transform = ''; });

    /* ---------- fit finder (three taps) ---------- */
    function openFit() { if (fit) fit.classList.add('is-open'); document.body.style.overflow = 'hidden'; syncHeader(); }
    function closeFit() { if (fit) fit.classList.remove('is-open'); if (!anyOpen()) document.body.style.overflow = ''; syncHeader(); }
    root.querySelectorAll('[data-open-fit]').forEach(function (b) { b.addEventListener('click', function () { closeChart(); openFit(); }); });
    root.querySelectorAll('[data-close-fit]').forEach(function (b) { b.addEventListener('click', closeFit); });
    /* Esc closes whichever overlay is open */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.keyCode !== 27) return;
      if (fit && fit.classList.contains('is-open')) closeFit();
      else if (chart && chart.classList.contains('is-open')) closeChart();
    });

    var SIZES = Array.prototype.map.call(root.querySelectorAll('.ac-pdp-size'), function (b) { return b.dataset.size; });
    var NOTES = ['A closer line.', 'A comfortable fit.', 'Room to move.'];
    var pick = { h: 2, b: 1, fit: 1 };
    var fitShirt = root.querySelector('[data-fit-shirt]');
    var recSizeEl = root.querySelector('[data-rec-size]');
    var recNoteEl = root.querySelector('[data-rec-note]');
    var addFitBtn = root.querySelector('[data-add-fit]');

    function recompute() {
      var idx = pick.h + 1 + (pick.b - 1) + (pick.fit - 1);
      idx = Math.max(0, Math.min(SIZES.length - 1, idx));
      var size = SIZES[idx] || '';
      if (recSizeEl) recSizeEl.textContent = size;
      if (recNoteEl) recNoteEl.textContent = NOTES[pick.fit] || '';
      if (addFitBtn) { addFitBtn.dataset.size = size; var lbl = addFitBtn.querySelector('[data-add-fit-label]'); if (lbl) lbl.textContent = 'ADD SIZE ' + size; }
      if (fitShirt) { var w = 0.9 + idx * 0.045, h = 0.96 + idx * 0.016; fitShirt.style.transform = 'scaleX(' + w + ') scaleY(' + h + ')'; }
    }
    root.querySelectorAll('[data-fit-chip]').forEach(function (c) {
      c.addEventListener('click', function () {
        var dim = c.dataset.dim, val = parseInt(c.dataset.val, 10);
        pick[dim] = val;
        root.querySelectorAll('[data-fit-chip][data-dim="' + dim + '"]').forEach(function (x) { x.classList.toggle('is-active', x === c); });
        recompute();
      });
    });
    if (addFitBtn) addFitBtn.addEventListener('click', function () {
      var size = addFitBtn.dataset.size;
      if (size) selectSize(size);
      closeFit();
      var f = forms[0];
      forms.forEach(function (x) { if (x.offsetParent !== null) f = x; });
      var vi = f && f.querySelector('[data-variant-input]');
      if (f && vi && vi.value) { if (f.requestSubmit) f.requestSubmit(); else f.querySelector('[type=submit]').click(); }
    });
    recompute();
  });

  /* mouse-drag horizontal scroll (touch is already native); makes swipe work in the desktop editor too */
  function enableMouseDrag(el) {
    var down = false, startX = 0, startL = 0, moved = false;
    el.addEventListener('mousedown', function (e) { down = true; moved = false; startX = e.pageX; startL = el.scrollLeft; el.style.cursor = 'grabbing'; el.style.scrollSnapType = 'none'; });
    window.addEventListener('mousemove', function (e) { if (!down) return; var dx = e.pageX - startX; if (Math.abs(dx) > 4) moved = true; el.scrollLeft = startL - dx; });
    window.addEventListener('mouseup', function () { if (!down) return; down = false; el.style.cursor = ''; el.style.scrollSnapType = ''; if (moved) { var w = el.clientWidth; el.scrollTo({ left: Math.round(el.scrollLeft / w) * w, behavior: 'smooth' }); } });
    el.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  /* ---------- mobile hero: full-bleed swipe gallery, counter + live video ---------- */
  document.querySelectorAll('[data-mob-hero]').forEach(function (hero) {
    var slides = hero.querySelectorAll('.ac-pdp-mob-heroslide');
    var count = hero.parentNode.querySelector('[data-mob-count]');
    var n = slides.length;
    if (n < 2) return;
    function playOnly(idx) {
      slides.forEach(function (s, i) {
        var v = s.querySelector('[data-hover-video]');
        if (i === idx) { s.classList.add('is-live'); if (v) { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} } }
        else { s.classList.remove('is-live'); if (v) { try { v.pause(); } catch (e) {} } }
      });
    }
    var raf;
    hero.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var idx = Math.round(hero.scrollLeft / hero.clientWidth);
        idx = Math.max(0, Math.min(n - 1, idx));
        if (count) count.textContent = ('0' + (idx + 1)).slice(-2) + ' / ' + ('0' + n).slice(-2);
        playOnly(idx);
      });
    }, { passive: true });
    playOnly(0);
    enableMouseDrag(hero);
  });
  document.querySelectorAll('[data-mob-slider]').forEach(function (slider) {
    var slides = slider.querySelectorAll('.ac-pdp-mob-slide');
    var dotsWrap = slider.parentNode.querySelector('[data-mob-dots]');
    if (!slides.length || !dotsWrap) return;
    slides.forEach(function (_, i) { var d = document.createElement('i'); if (i === 0) d.className = 'is-active'; dotsWrap.appendChild(d); });
    var dots = dotsWrap.querySelectorAll('i');
    function playOnly(idx) {
      slides.forEach(function (s, i) {
        var v = s.querySelector('[data-hover-video]');
        if (i === idx) { s.classList.add('is-live'); if (v) { try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} } }
        else { s.classList.remove('is-live'); if (v) { try { v.pause(); } catch (e) {} } }
      });
    }
    var raf;
    slider.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var idx = Math.round(slider.scrollLeft / (slides[0].offsetWidth + 10));
        idx = Math.max(0, Math.min(slides.length - 1, idx));
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        playOnly(idx);
      });
    }, { passive: true });
    playOnly(0);
    enableMouseDrag(slider);
  });
})();
